export const participationMenus = [
  {
    id: '1',
    label: '연구인재 양성',
    sub: [
    ]
  },
  {
    id: '1',
    label: '시민사회인재 양성',
    sub: [
    ]
  },
  {
    id: '1',
    label: '시민아이디어 지원',
    sub: [
    ]
  },
  {
    id: '1',
    label: '그린아고라',
    sub: [
    ]
  },
  {
    id: '1',
    label: '교육·문화·정보·협력사업',
    sub: [
    ]
  },
]

export const activityTitles = (category: string) => {
  switch (category) {
    case '36':
      return '선정프로젝트';
      break;
    case '41':
      return '선정팀 명단';
      break;
    case '33':
      return '풀꽃 선발리스트';
      break;
    case '35':
      return '최종 선정리스트';
      break;
    case '47':
      return '';
      break;
    default:
      return window.__LANG__ === 'en' ? 'Awardees List' : '활동성과';
      break;    
  }
}

export const activityRecentPostsStyle = (boardId: string) => {
  switch (boardId) {
    case '29':
      return 'thumbnail';
      break;
    default:
      return 'list';
      break;
  }
}
